import { render, staticRenderFns } from "./StatusRenderer.vue?vue&type=template&id=28d48c1c&"
import script from "./StatusRenderer.vue?vue&type=script&lang=js&"
export * from "./StatusRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports